"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LineItemRow = void 0;
var react_1 = __importDefault(require("react"));
var TokenRenderer_1 = __importDefault(require("@CommonFrontend/ContentTokens/TokenRenderer"));
var Recurrence_1 = require("@CommonFrontendBackend/QuoteV2/Recurrence");
var Types_1 = require("@CommonFrontendBackend/QuoteV2/Types");
var QuoteSummaryContextProvider_1 = require("./QuoteSummaryContextProvider");
var styles = __importStar(require("./QuoteSummaryWidget.css"));
var Utils_1 = require("./Utils");
var DiscountableTotal_1 = require("./DiscountableTotal");
var LineItemDescription = function (_a) {
    var item = _a.item;
    var settings = (0, QuoteSummaryContextProvider_1.useQuoteSummaryContext)().settings;
    if (!item.description || !item.description.tokens || item.description.tokens.length === 0) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    var tokens = item.description.tokens;
    if (settings.compactLineItemDescriptions) {
        tokens = (0, Utils_1.getFirstContentOfType)(item.description.tokens, ["paragraph"]);
    }
    return (react_1.default.createElement("div", { dangerouslySetInnerHTML: {
            __html: (0, TokenRenderer_1.default)(tokens),
        } }));
};
var LineItemRow = function (_a) {
    var _b;
    var item = _a.item, sectionViewSettings = _a.sectionViewSettings, labelSetId = _a.labelSetId, isLastRow = _a.isLastRow;
    var _c = (0, QuoteSummaryContextProvider_1.useQuoteSummaryContext)(), formatCurrency = _c.formatCurrency, getLabel = _c.getLabel, settings = _c.settings;
    var showItemDescription = sectionViewSettings.showItemDescription, showItemQuantity = sectionViewSettings.showItemQuantity, showItemRate = sectionViewSettings.showItemRate, showItemTotal = sectionViewSettings.showItemTotal;
    switch (item.type) {
        case Types_1.QuoteItemType.Variable:
        case Types_1.QuoteItemType.FixedCost: {
            return (react_1.default.createElement("tr", { className: styles.lineItem({ isLastRow: isLastRow }) },
                react_1.default.createElement("td", { className: styles.cell({ isFirstColumn: true }) }, showItemDescription && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(LineItemDescription, { item: item }),
                    settings.showFeatureLists && item.featureList && (react_1.default.createElement("div", { className: styles.lineItemFeatureList, dangerouslySetInnerHTML: {
                            __html: (0, TokenRenderer_1.default)((_b = item.featureList.tokens) !== null && _b !== void 0 ? _b : []),
                        } }))))),
                react_1.default.createElement("td", { className: styles.cell() }, showItemRate && react_1.default.createElement("p", null, formatCurrency(item.rate.rate))),
                react_1.default.createElement("td", { className: styles.cell() }, showItemQuantity && (react_1.default.createElement("p", null,
                    item.quantity,
                    " ",
                    item.rate.unit))),
                react_1.default.createElement("td", { className: styles.cell({ align: "right" }) }, showItemTotal && (react_1.default.createElement(DiscountableTotal_1.DiscountableTotal, { labelSetId: labelSetId, discount: item.discount, preDiscount: item.total.preDiscount, preTax: item.total.preTax, frequencyLabel: (0, Types_1.isRecurringSchedule)(item.total.billingSchedule)
                        ? getLabel(labelSetId, (0, Recurrence_1.mapRecurringFrequencyToPerLabel)(item.total.billingSchedule.frequency))
                        : undefined })))));
        }
        default:
        case Types_1.QuoteItemType.Text: {
            if (showItemDescription) {
                return (react_1.default.createElement("tr", { className: styles.lineItem({ isLastRow: isLastRow }) },
                    react_1.default.createElement("td", { className: styles.cell({ isFirstColumn: true }) },
                        react_1.default.createElement(LineItemDescription, { item: item })),
                    react_1.default.createElement("td", { className: styles.cell(), "aria-hidden": true }),
                    react_1.default.createElement("td", { className: styles.cell(), "aria-hidden": true }),
                    react_1.default.createElement("td", { className: styles.cell(), "aria-hidden": true })));
            }
            return react_1.default.createElement(react_1.default.Fragment, null);
        }
    }
};
exports.LineItemRow = LineItemRow;
